<template>
    <div>
        <!-- Post-draw settings update for current reward -->
        <h5 class="mb-2 mt-4">抽選後重複設定</h5>
        <div v-for="(field, idx) in globalPostDrawFields" :key="'res-post-' + idx" class="d-flex align-items-center mb-2">
            <Multiselect
                :id="'res-post-dup-' + idx"
                :value.sync="globalPostDrawFields[idx]"
                :options="listBlockForm"
                :config="{ trackBy: 'id', label: 'block_name', isRemove: true }"
                style="min-width: 220px"
                class="w-50"
            />
            <button type="button" class="btn btn-sm btn-success ml-2" @click="addPostDrawField"><i class="ri-add-line"></i></button>
            <button type="button" class="btn btn-sm btn-danger ml-1" @click="removePostDrawField(idx)">
                <i class="ri-subtract-line"></i>
            </button>
        </div>
        <button type="button" class="btn btn-sm btn-success mb-2" @click="addPostDrawField" v-if="globalPostDrawFields.length === 0">
            <i class="ri-add-line"></i>
        </button>

        <div class="custom-control custom-checkbox mt-2 mb-3">
            <input type="checkbox" class="custom-control-input" id="resFullDataDup" v-model="globalFullDataDuplicateEnabled" />
            <label class="custom-control-label" for="resFullDataDup"> データ全体の重複設定 </label>
            <p class="text-danger small mb-0">
                「データ全体の重複設定」にチェックを入れている場合、検索結果にかかわらず、データ全体で重複設定のデータを検索し、
                <br />「当選」フラグがたっている場合、当選にならない
            </p>
        </div>

        <!-- Winner tabs by reward -->
        <div v-if="rewards.length">
            <ul class="nav nav-tabs mb-4 mt-3">
                <li class="nav-item" v-for="(r, idx) in rewards" :key="'tab-' + idx">
                    <a class="nav-link" :class="{ active: selectedRewardIdx === idx }" href="javascript:void(0)" @click="selectReward(idx)">
                        {{ r.text || '当選設定 ' + (idx + 1) }}
                    </a>
                </li>
            </ul>

            <div class="d-flex justify-content-end mb-4 align-items-center">
                <button type="button" class="btn btn-outline-secondary mr-3 px-4" @click="clearCurrentRewardResultSettings">削除</button>
                <button
                    v-if="checkPermission('lottery.draw')"
                    type="button"
                    class="btn btn-info px-4"
                    :disabled="isDrawing"
                    @click="$emit('submit-then-draw', selectedRewardIdx)"
                >
                    <span v-if="isDrawing"><i class="ri-loader-4-line"></i> 抽選中...</span>
                    <span v-else>抽選する</span>
                </button>
            </div>

            <hr class="mb-4" />

            <div class="tab-content" v-if="rewards[selectedRewardIdx]">
                <!-- Winners Table -->
                <div class="d-flex justify-content-end mb-2">
                    <!-- <button type="button" class="btn btn-primary btn-sm" @click="openModalCreateWinner"><i class="ri-add-line"></i> 新規作成</button> -->
                    <button
                        v-if="checkPermission('lottery.export')"
                        type="button"
                        class="btn btn-common btn-success"
                        :disabled="isExporting"
                        @click="doExport"
                    >
                        <span v-if="isExporting"><i class="ri-loader-4-line bx-spin"></i> ダウンロード中..</span>
                        <span v-else><i class="ri-file-download-line"></i> データダウンロード</span>
                    </button>
                </div>
                <div class="table-responsive">
                    <TableListComponent
                        :config="configResultTable"
                        :dataList="winners"
                        :isLoading="isLoadingWinners"
                        :configPage.sync="configPageWinners"
                        @onChangePage="onWinnersPageChange"
                    >
                        <template #row="{ row }">
                            <tr>
                                <td class="text-left">
                                    {{ row.external_data_index || (row.winner_snapshot ? row.winner_snapshot.submit_index : row.submit_index) }}
                                </td>
                                <td>
                                    <div class="el-table__cell text-left">
                                        {{
                                            formatDateCommon(
                                                row.winner_snapshot && row.winner_snapshot.submitted_at
                                                    ? row.winner_snapshot.submitted_at
                                                    : row.created_at || row.submitted_at,
                                                'dateTimeJP'
                                            )
                                        }}
                                    </div>
                                </td>
                                <td v-for="b in listBlockForm" :key="b.id">
                                    <div
                                        class="el-table__cell text-left"
                                        v-html="
                                            renderLineBreaks(
                                                row.external_data_id && row.winner_snapshot
                                                    ? row.winner_snapshot[b.id]
                                                    : getBlockValue(row.winner_snapshot ? row.winner_snapshot.submit_results : row.blocks, b.id)
                                            )
                                        "
                                    ></div>
                                </td>
                                <td>
                                    <div class="el-table__cell text-left">
                                        {{ (row.tags || []).join(', ') }}
                                    </div>
                                </td>
                                <td>
                                    <div class="el-table__cell text-left">
                                        <template v-if="!isEditing(row)">
                                            {{ row.reward_text }}
                                        </template>
                                        <input
                                            v-else
                                            type="text"
                                            class="form-control form-control-sm"
                                            v-model="editingWinner.reward_text"
                                            style="min-width: 120px"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div class="el-table__cell text-left">
                                        <template v-if="!isEditing(row)">
                                            <span v-if="row.winner_flag" class="badge badge-success">当選</span>
                                            <span v-else class="badge badge-secondary">落選</span>
                                        </template>
                                        <select
                                            v-else
                                            class="form-control form-control-sm"
                                            v-model="editingWinner.winner_flag"
                                            style="min-width: 100px"
                                        >
                                            <option :value="true">当選</option>
                                            <option :value="false">落選</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="sticky_action">
                                    <div class="text-left">
                                        <template v-if="!isEditing(row)">
                                            <button v-if="checkPermission('lottery.edit')" class="btn btn-sm btn-info mr-1" @click="startEdit(row)">
                                                編集
                                            </button>
                                            <button
                                                v-if="checkPermission('lottery.delete')"
                                                class="btn btn-sm btn-danger"
                                                @click="doDeleteWinner(row)"
                                            >
                                                削除
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-sm btn-success mr-1" @click="doUpdateWinner">保存</button>
                                            <button class="btn btn-sm btn-secondary" @click="editingWinner = null">キャンセル</button>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </TableListComponent>
                </div>
            </div>
        </div>

        <b-modal id="modal-create-winner" title="新規作成" hide-footer @hidden="resetNewWinnerForm">
            <div class="form-group" v-for="b in listBlockForm" :key="'new-' + b.id">
                <label>{{ b.block_name }}</label>
                <input type="text" class="form-control" v-model="newWinnerForm[b.block_name]" />
            </div>
            <div class="form-group">
                <label>当選テキスト</label>
                <input type="text" class="form-control" v-model="newWinnerForm.reward_text" />
            </div>
            <div class="form-group">
                <label>当選フラグ</label>
                <select class="form-control" v-model="newWinnerForm.winner_flag">
                    <option :value="true">当選</option>
                    <option :value="false">落選</option>
                </select>
            </div>
            <div class="text-right">
                <button type="button" class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-create-winner')">キャンセル</button>
                <button type="button" class="btn btn-primary" @click="submitNewWinner">保存</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import Multiselect from '@/components/Multiselect/main.vue';
import { showMessage } from '@/utils/messages';
import { lotteryMethods, uploadMethods } from '@/state/helpers';
import TableListComponent from '@/components/TableList/main.vue';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { checkPermission } from '@/utils/handlers';
import { formatDateCommon, renderLineBreaks } from '@/utils/format';

export default {
    components: { Multiselect, TableListComponent },
    props: {
        lotteryId: { type: [Number, String], default: null },
        listBlockForm: { type: Array, default: () => [] },
        rewards: { type: Array, default: () => [] },
        postDrawConfig: { type: Object, default: () => null },
        fullDataDup: { type: Boolean, default: false }
    },
    data() {
        return {
            ALL_BLOCK_TYPE,
            isDrawing: false,
            isExporting: false,
            exportPollingTimer: null,
            drawPollingTimer: null,
            selectedRewardIdx: 0,
            winners: [],
            isLoadingWinners: false,
            editingWinner: null,
            newWinnerForm: {},
            globalPostDrawFields: [null],
            globalFullDataDuplicateEnabled: false,
            configResultTable: {
                headers: [
                    { label: 'ID', width: 60 },
                    { label: '回答日時', width: 160 },
                    { label: '登録タグ', width: 200 },
                    { label: '当選テキスト', width: 150 },
                    { label: '当選フラグ', width: 120 },
                    { label: '操作', width: 150 }
                ]
            },
            configPageWinners: {
                page: 1,
                limit: 10,
                total: 0
            }
        };
    },
    async mounted() {
        this.selectReward(0);
        this.initData();
    },
    watch: {
        postDrawConfig: {
            handler() {
                this.initData();
            },
            deep: true
        },
        fullDataDup() {
            this.globalFullDataDuplicateEnabled = this.fullDataDup;
        },
        listBlockForm: {
            handler(newBlocks) {
                this.configResultTable = {
                    headers: [
                        { label: 'ID', width: 60 },
                        { label: '回答日時', width: 160 },
                        ...newBlocks.map((b) => ({ label: b.block_name, width: 200 })),
                        { label: '登録タグ', width: 200 },
                        { label: '当選テキスト', width: 150 },
                        { label: '当選フラグ', width: 120 },
                        { label: '操作', width: 150 }
                    ]
                };
            },
            immediate: true,
            deep: true
        }
    },
    computed: {},
    methods: {
        ...lotteryMethods,
        ...uploadMethods,
        checkPermission,
        initData() {
            if (this.postDrawConfig) {
                const fields = this.postDrawConfig.fields || [];
                this.globalPostDrawFields = fields.map(
                    (fId) => this.listBlockForm.find((b) => b.id == fId) || { id: fId, block_name: 'Unknown Field' }
                );
                if (this.globalPostDrawFields.length === 0) this.globalPostDrawFields = [null];
            } else {
                this.globalPostDrawFields = [null];
            }
            this.globalFullDataDuplicateEnabled = this.fullDataDup;
        },
        formatDateCommon,
        renderLineBreaks,
        addPostDrawField() {
            this.globalPostDrawFields.push(null);
        },
        removePostDrawField(idx) {
            this.globalPostDrawFields.splice(idx, 1);
        },
        clearCurrentRewardResultSettings() {
            this.globalPostDrawFields = [null];
            this.globalFullDataDuplicateEnabled = false;
        },
        async executeDraw(rewardIndex = null) {
            if (!this.lotteryId) return;
            const targetRewardIndex =
                rewardIndex !== null && rewardIndex !== undefined
                    ? Number(rewardIndex)
                    : this.selectedRewardIdx !== null && this.selectedRewardIdx !== undefined
                      ? Number(this.selectedRewardIdx)
                      : 0;
            this.isDrawing = true;
            try {
                const payload = {
                    reward_index: targetRewardIndex,
                    post_draw_duplicate_config: {
                        enabled: this.globalPostDrawFields.filter((f) => f && f.id).length > 0,
                        fields: this.globalPostDrawFields.filter((f) => f && f.id).map((f) => String(f.id))
                    },
                    full_data_duplicate_enabled: this.globalFullDataDuplicateEnabled
                };
                this.$emit('update:postDrawConfig', payload.post_draw_duplicate_config);
                this.$emit('update:fullDataDup', payload.full_data_duplicate_enabled);

                const res = await this.drawLottery({ id: this.lotteryId, data: payload });
                const drawId = res?.data?.id || res?.id;
                if (drawId) {
                    this.pollDrawStatus(drawId);
                } else {
                    this.isDrawing = false;
                    if (res?.code && res.code >= 400) {
                        const message =
                            (this.$te && this.$te(res.message) ? this.$t(res.message) : '') ||
                            (this.$t && this.$t(res.message) !== res.message ? this.$t(res.message) : '') ||
                            res.message ||
                            '抽選に失敗しました';
                        showMessage(res.code, this.$bvToast, message);
                    }
                }
            } catch (e) {
                this.isDrawing = false;
                console.error(e);
                const message =
                    (e?.message && this.$te && this.$te(e.message) ? this.$t(e.message) : '') ||
                    (e?.message && this.$t && this.$t(e.message) !== e.message ? this.$t(e.message) : '') ||
                    e?.message ||
                    '抽選に失敗しました';
                showMessage(e?.code || 500, this.$bvToast, message);
            }
        },
        pollDrawStatus(drawId) {
            clearInterval(this.drawPollingTimer);
            clearInterval(this.exportPollingTimer);
            this.drawPollingTimer = setInterval(async () => {
                try {
                    const res = await this.drawStatus({ lotteryId: this.lotteryId, drawId });
                    const status = res?.data?.status || res?.status;
                    if (status === 'completed' || status === 'success') {
                        clearInterval(this.drawPollingTimer);
                        this.isDrawing = false;
                        this.selectReward(this.selectedRewardIdx);
                    } else if (status === 'failed') {
                        clearInterval(this.drawPollingTimer);
                        this.isDrawing = false;
                        showMessage(500, this.$bvToast, '抽選に失敗しました');
                    }
                } catch (e) {
                    clearInterval(this.drawPollingTimer);
                    this.isDrawing = false;
                }
            }, 3000);
        },
        openModalCreateWinner() {
            this.resetNewWinnerForm();
            this.$bvModal.show('modal-create-winner');
        },
        resetNewWinnerForm() {
            this.newWinnerForm = {};
            if (this.listBlockForm) {
                this.listBlockForm.forEach((b) => {
                    this.$set(this.newWinnerForm, b.block_name, '');
                });
            }
            this.$set(this.newWinnerForm, 'reward_text', '');
            this.$set(this.newWinnerForm, 'winner_flag', true);
        },
        async submitNewWinner() {
            try {
                const snapshot = {};
                if (this.listBlockForm) {
                    this.listBlockForm.forEach((b) => {
                        snapshot[b.block_name] = this.newWinnerForm[b.block_name];
                    });
                }
                const res = await this.addWinner({
                    lotteryId: this.lotteryId,
                    data: {
                        reward_index: this.selectedRewardIdx,
                        reward_text: this.newWinnerForm.reward_text,
                        winner_flag: this.newWinnerForm.winner_flag === true || this.newWinnerForm.winner_flag === 'true',
                        winner_snapshot: snapshot
                    }
                });
                const isError = res?.code && res.code !== 200 && res.code !== 201;
                if (isError) {
                    const message =
                        (this.$te && this.$te(res.message) ? this.$t(res.message) : '') ||
                        (this.$t && this.$t(res.message) !== res.message ? this.$t(res.message) : '') ||
                        (res.message === 'lottery.reward_quantity_exceeded'
                            ? '当選数が設定された賞品数を超えています。'
                            : res.message || '作成に失敗しました');
                    showMessage(res.code, this.$bvToast, message);
                    return;
                }
                showMessage(200, this.$bvToast, '作成しました');
                this.$bvModal.hide('modal-create-winner');
                this.selectReward(this.selectedRewardIdx);
            } catch (e) {
                console.error(e);
                const message =
                    (e?.message && this.$te && this.$te(e.message) ? this.$t(e.message) : '') ||
                    (e?.message && this.$t && this.$t(e.message) !== e.message ? this.$t(e.message) : '') ||
                    (e?.message === 'lottery.reward_quantity_exceeded'
                        ? '当選数が設定された賞品数を超えています。'
                        : e?.message || '作成に失敗しました');
                showMessage(e?.code || 500, this.$bvToast, message);
            }
        },
        async selectReward(idx) {
            this.selectedRewardIdx = idx;
            this.configPageWinners.page = 1;
            await this.fetchWinners();
        },

        async fetchWinners() {
            if (!this.lotteryId) return;
            this.isLoadingWinners = true;
            this.winners = [];
            try {
                const { page, limit } = this.configPageWinners;
                const res = await this.listWinners({
                    id: this.lotteryId,
                    query: `filters[reward_index]=${this.selectedRewardIdx}&page=${page}&limit=${limit}`
                });
                this.winners = res?.data || [];
                const meta = res?._metadata || res?.metadata;
                if (meta?.total !== undefined) {
                    this.configPageWinners.total = meta.total;
                } else {
                    this.configPageWinners.total = this.winners.length;
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoadingWinners = false;
            }
        },

        onWinnersPageChange() {
            this.fetchWinners();
        },
        startEdit(row) {
            this.editingWinner = { ...row };
        },
        isEditing(row) {
            if (!this.editingWinner || !row) return false;
            if (this.editingWinner.external_data_id && row.external_data_id) {
                return this.editingWinner.external_data_id === row.external_data_id;
            }
            if (this.editingWinner.form_submission_id && row.form_submission_id) {
                return this.editingWinner.form_submission_id === row.form_submission_id;
            }
            if (this.editingWinner.id && row.id) {
                return this.editingWinner.id === row.id;
            }
            return false;
        },
        async doUpdateWinner() {
            if (!this.editingWinner) return;
            try {
                const flag = this.editingWinner.winner_flag === true || this.editingWinner.winner_flag === 'true';
                let snapshot = this.editingWinner.winner_snapshot;
                if (typeof snapshot === 'string') {
                    try {
                        snapshot = JSON.parse(snapshot);
                    } catch (e) {
                        // ignore
                    }
                }
                const payload = {
                    id: this.editingWinner.id || null,
                    form_submission_id: this.editingWinner.form_submission_id || null,
                    external_data_id: this.editingWinner.external_data_id || null,
                    reward_index:
                        this.editingWinner.reward_index !== undefined && this.editingWinner.reward_index !== null
                            ? this.editingWinner.reward_index
                            : this.selectedRewardIdx ?? 0,
                    reward_text: this.editingWinner.reward_text,
                    winner_flag: flag,
                    winner_snapshot: snapshot || {}
                };
                const res = await this.updateWinner({
                    lotteryId: this.lotteryId,
                    data: payload
                });
                const isError = res?.code && res.code !== 200 && res.code !== 201;
                if (isError) {
                    const message =
                        (this.$te && this.$te(res.message) ? this.$t(res.message) : '') ||
                        (this.$t && this.$t(res.message) !== res.message ? this.$t(res.message) : '') ||
                        (res.message === 'lottery.reward_quantity_exceeded'
                            ? '当選数が設定された賞品数を超えています。'
                            : res.message || '更新に失敗しました');
                    showMessage(res.code, this.$bvToast, message);
                    return;
                }
                showMessage(200, this.$bvToast, '更新しました');
                this.editingWinner = null;
                this.fetchWinners();
            } catch (e) {
                console.error(e);
                const message =
                    (e?.message && this.$te && this.$te(e.message) ? this.$t(e.message) : '') ||
                    (e?.message && this.$t && this.$t(e.message) !== e.message ? this.$t(e.message) : '') ||
                    (e?.message === 'lottery.reward_quantity_exceeded'
                        ? '当選数が設定された賞品数を超えています。'
                        : e?.message || '更新に失敗しました');
                showMessage(e?.code || 500, this.$bvToast, message);
            }
        },
        async doDeleteWinner(row) {
            Swal.fire({
                title: 'この当選結果を削除してもよろしいですか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#556ee6',
                cancelButtonColor: '#e8ecf4',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'OK'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const payload = {
                            id: row.id || null,
                            form_submission_id: row.form_submission_id || null,
                            external_data_id: row.external_data_id || null
                        };
                        const res = await this.deleteWinner({
                            lotteryId: this.lotteryId,
                            data: payload
                        });
                        const isError = res?.code && res.code !== 200 && res.code !== 204;
                        if (isError) {
                            const message =
                                (this.$te && this.$te(res.message) ? this.$t(res.message) : '') ||
                                (this.$t && this.$t(res.message) !== res.message ? this.$t(res.message) : '') ||
                                res.message ||
                                '削除に失敗しました';
                            showMessage(res.code, this.$bvToast, message);
                            return;
                        }
                        showMessage(200, this.$bvToast, '削除しました');
                        this.fetchWinners();
                    } catch (e) {
                        console.error(e);
                        const message =
                            (e?.message && this.$te && this.$te(e.message) ? this.$t(e.message) : '') ||
                            (e?.message && this.$t && this.$t(e.message) !== e.message ? this.$t(e.message) : '') ||
                            e?.message ||
                            '削除に失敗しました';
                        showMessage(e?.code || 500, this.$bvToast, message);
                    }
                }
            });
        },
        async doExport() {
            if (!this.lotteryId || this.selectedRewardIdx === null) return;
            this.isExporting = true;
            try {
                const query = `filters[reward_index]=${this.selectedRewardIdx}`;
                const res = await this.exportWinners({ id: this.lotteryId, query });
                console.log('出力 Winners Response:', res);
                const fileId = res?.data?.file_id || res?.file_id || res?.data?.id || res?.id;
                if (fileId) {
                    this.pollExportStatus(fileId);
                } else {
                    this.isExporting = false;
                    showMessage(
                        500,
                        this.$bvToast,
                        'ファイルのダウンロードに失敗しました (file_idなし). Response: ' + JSON.stringify(res).substring(0, 100)
                    );
                }
            } catch (e) {
                this.isExporting = false;
                console.error('出力 Error:', e);
            }
        },
        pollExportStatus(fileId) {
            clearInterval(this.exportPollingTimer);
            this.exportPollingTimer = setInterval(async () => {
                try {
                    const res = await this.acgetJobStatusFile(fileId);
                    console.log('Poll Export Status Response:', res);
                    const status = res?.data?.status || res?.status;
                    if (status == 1 || status === 'completed') {
                        clearInterval(this.exportPollingTimer);
                        this.isExporting = false;
                        const fileUrl = res?.data?.path || res?.path;
                        if (fileUrl) {
                            window.location.href = fileUrl;
                        } else {
                            showMessage(500, this.$bvToast, 'ファイルのダウンロードに失敗しました (file_urlなし)');
                        }
                    } else if (status == 2 || status === 'failed') {
                        clearInterval(this.exportPollingTimer);
                        this.isExporting = false;
                        showMessage(500, this.$bvToast, 'ファイルのダウンロードに失敗しました (ステータス failed)');
                    }
                } catch (e) {
                    clearInterval(this.exportPollingTimer);
                    this.isExporting = false;
                    console.error('Poll Error:', e);
                }
            }, 3000);
        },
        getBlockValue(blocks, blockId) {
            if (!blocks || !Array.isArray(blocks)) return '';
            const blockForm = this.listBlockForm.find((b) => b.id === blockId || b.id === String(blockId));
            if (!blockForm) return '';

            const result = blocks.find((item) => item.block_id === blockId || item.id === blockId || item.block_id === String(blockId));
            const resultValue = result?.answers?.[0];
            const listValueToString =
                result?.answers
                    ?.map((item) => {
                        return item.is_custom_value
                            ? `${blockForm.extension?.setting_others?.label_other || 'その他'}(${item.value ?? ''})`
                            : item.value ?? '';
                    })
                    ?.toString() ?? '';

            switch (blockForm.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    return resultValue?.file?.file_name || resultValue?.file || '';
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (resultValue?.is_custom_value) {
                        return `${blockForm.extension?.setting_others?.label_other || 'その他'}(${resultValue.value ?? ''})`;
                    } else {
                        return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
                    }
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    return listValueToString;
                default:
                    return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.drawPollingTimer);
    }
};
</script>
